const TOUCH_ID = {
    INIT_VIEW: require('./view/touch_id_init.html'),
    MODIFY_VIEW: require('./view/touch_id_modify.html'),

    ACTIVATION_BUTTON_CONFIRM: '.cgp-touch-id-init-button',
    ELEMENT_CHECKBOX_LABEL: '.cgp-touch-id-modify-toggle-button',
    ELEMENT_CHECKBOX: '.cgp-touch-id-modify-toggle-button-checkbox'
};


const TOUCH_ID_SCREENS = {
    INIT_SCREEN: '1',
    MODIFY_SCREEN: '2',
    TOUCH_ID_CTL_OPENED: 'thocu_id_ctl_opened',
    TOUCH_ID_CTL_CLOSED: 'thocu_id_ctl_closed'
};

export {TOUCH_ID, TOUCH_ID_SCREENS};
